import io from "socket.io-client";

let socketInstance = null;

class IO {
  constructor() {
    if (!socketInstance) {
      socketInstance = this;
    }

    this._socket = io("http://backend-alpha.aprovatotal.com.br");

    return socketInstance;
  }

  get socket() {
    return this._socket;
  }

  set socket(socket) {
    this._socket = socket;
  }
}

export default IO;
